import { render, staticRenderFns } from "./SubscriptionManager.vue?vue&type=template&id=486e0580"
import script from "./SubscriptionManager.vue?vue&type=script&lang=js"
export * from "./SubscriptionManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports